import { render, staticRenderFns } from "./BasketView.vue?vue&type=template&id=6df76594&scoped=true&"
import script from "./BasketView.vue?vue&type=script&lang=js&"
export * from "./BasketView.vue?vue&type=script&lang=js&"
import style0 from "./BasketView.vue?vue&type=style&index=0&id=6df76594&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df76594",
  null
  
)

export default component.exports